<div class="header-jumbotron">
  <div class="header-jumbotron-logo" (click)="onLogoClick()" title="{{ 'toStartPage' | translate }}">
    <img [src]="'assets/mandanten/' + window.mandant + '/default-logo.png'" alt="Logo" class="header-jumbotron-img" />
  </div>

  <span class="header-jumbotron-text prime-fg-color-1">{{ PortalTitel }}</span>

  <div class="header-jumbotron-anmelden prime-fg-color-1">
    <div class="user-menu">
      <dx-menu
        #userMenu
        [dataSource]="userMenuItems"
        displayExpr="text"
        [showFirstSubmenuMode]="{ name: 'onClick' }"
        orientation="horizontal"
        submenuDirection="auto"
        [hideSubmenuOnMouseLeave]="false"
        hint="{{ 'login' | translate }}"
        (onItemClick)="onMenuItemClick($event)"
      ></dx-menu>
    </div>

    <div class="header-jumbotron-menu-btn">
      <dx-menu
        #userMenu
        [dataSource]="menuitemsHandyModus"
        displayExpr="text"
        [showFirstSubmenuMode]="{ name: 'onClick' }"
        orientation="horizontal"
        submenuDirection="auto"
        [hideSubmenuOnMouseLeave]="false"
        (onItemClick)="onMenuItemClick($event)"
      ></dx-menu>
    </div>

    <div *ngIf="changeLanguage" class="header-jumbotron-language-container">
      <dx-menu [items]="languages" itemTemplate="items" [showFirstSubmenuMode]="{ name: 'onClick' }" cssClass="lang-menu">
        <div *dxTemplate="let item of 'items'">
          <img class="lang-img" [src]="item.image" width="35px" height="23px" title="{{ item.text | translate }}" />
        </div>
      </dx-menu>
    </div>
  </div>
</div>

<div class="menu-list">
  <dx-menu
    class="header-menu-1"
    [selectedItem]="selectedItemLeft"
    #menuLeft
    [dataSource]="menuitemsLeft"
    displayExpr="text"
    orientation="horizontal"
    submenuDirection="auto"
    (onItemClick)="onMenuItemClick($event)"
  >
  </dx-menu>

  <dx-menu
    class="header-menu-1 right"
    [selectedItem]="selectedItemRight"
    #menuRight
    [dataSource]="menuitemsRight"
    displayExpr="text"
    orientation="horizontal"
    submenuDirection="auto"
    (onItemClick)="onMenuItemClick($event)"
  >
  </dx-menu>
</div>
